import React, { lazy } from "react";
import HomeIcon from "../components/HomeIcon";
import OneLogo from "../components/ComQalqiOneLogo";
import InfoIcon from "../components/InfoIcon";
import ExternalIcon from "../components/ExternalIcon";

export type SlideKey = "home" | "1234" | "info" | "family";

export interface SlideConfig {
    key: SlideKey;
    type: "slide" | "link";
    lazyComponent?: React.LazyExoticComponent<React.FC<any>>;
    component?: React.ReactNode; // For non-lazy or links
    elementId?: string;
    hash?: string;
    url?: string;
    label: string;
    icon: React.FC<any>;
    iconColor?: string;
}

const Home = lazy(() => import("../pages/home"));
const One = lazy(() => import("../pages/one"));
const CompanyDetails = lazy(() => import("../pages/companydetails"));

export const slides: SlideConfig[] = [
    {
        key: "home",
        type: "slide",
        lazyComponent: Home,
        elementId: "HomePage",
        hash: "#!home",
        label: "About",
        icon: HomeIcon,
        iconColor: "#C82128"
    },
    {
        key: "1234",
        type: "slide",
        lazyComponent: One,
        elementId: "OnePage",
        hash: "#!one",
        label: "1234 Go",
        icon: OneLogo,
        iconColor: "#4707CE"
    },
    {
        key: "info",
        type: "slide",
        lazyComponent: CompanyDetails,
        elementId: "SummaryPage",
        hash: "#!info",
        label: "Info",
        icon: InfoIcon,
        iconColor: "#C82128"
    },
    {
        key: "family",
        type: "link",
        component: null,
        url: "http://qrd.at/family",
        label: "Family Feels",
        icon: ExternalIcon,
        iconColor: "#474747ff"
    }
];
